export enum rideStopCargoStatus {
  PickedUp = 41,
  DroppedOff = 42,
  NotDroppedOff = 43,
  SkipDropOff = 44,
  Absent = 45,
  Scheduled = 12,
  CanceledDueToHoliday = 16,
  CanceledInAdvance = 17,
  CanceledLate = 18,
}

export enum cargoActionType {
  DropOff = 'Drop-off',
  PickUp = 'Pick-up'
}

export const StopCargoStatusDescription = (key: number) => {
  switch (key) {
    case rideStopCargoStatus.PickedUp:
      return 'Picked Up';
    case rideStopCargoStatus.DroppedOff:
      return 'Dropped Off';
    case rideStopCargoStatus.NotDroppedOff:
      return 'Not Dropped Off';
    case rideStopCargoStatus.Absent:
      return 'Absent';
    default:
      return 'None';
  }
};
